export type TagProps = {
  title: string;
  background?: boolean;
};

/**
 * タグ（単体）
 */
export default function Tag({ title, background = false }: TagProps) {
  const bg = background
    ? "border-GRAY_3 text-GRAY_1 bg-WHITE_1"
    : "border-GRAY_1 text-GRAY_1 bg-WHITE_1";

  return (
    <span className={`inline-flex items-center rounded-full border px-3.5 py-1 text-sm ${bg}`}>
      {title}
    </span>
  );
}
